module.exports = __webpack_public_path__ + "cab96d511924bc066648056a4677287e.png";